// extracted by mini-css-extract-plugin
export default {"LandingPage":"LandingPage_LandingPage__LVZPJ","LogoWrapper":"LandingPage_LogoWrapper__G5StS","Logo":"LandingPage_Logo__fHOWm"};